import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || String(error) };
  }

  componentDidCatch(error, info) {
    // Surface the real error to the console so it is never a silent black screen
    console.error("App crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: "100vh",
            background: "#0A0A0A",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Manrope, sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 520 }}>
            <div style={{ width: 40, height: 40, background: "#E31E24", margin: "0 auto 20px" }} />
            <h1 style={{ fontSize: 24, fontWeight: 800, textTransform: "uppercase", letterSpacing: "-0.02em" }}>
              Something went wrong
            </h1>
            <p style={{ color: "rgba(255,255,255,0.6)", marginTop: 12 }}>
              The page hit an unexpected error. Try reloading.
            </p>
            <pre style={{ color: "rgba(255,195,0,0.9)", fontSize: 12, marginTop: 16, whiteSpace: "pre-wrap" }}>
              {this.state.message}
            </pre>
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: 24,
                border: "1px solid #E31E24",
                color: "#E31E24",
                background: "transparent",
                padding: "12px 28px",
                textTransform: "uppercase",
                letterSpacing: "0.15em",
                fontSize: 12,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
